import { ActionCardsDbStore } from './actionCardsDbStore'
import { deleteFileQuestionsDb } from './dbService'

let isEnabled = true

const actionCardDbStore = new ActionCardsDbStore()

export function getIsStorageEnabled() {
  return isEnabled
}

export function setIsStorageActive(enable = true) {
  isEnabled = enable
}

export async function getLocalData(playbookId) {
  const key = getActionCardDataKey(playbookId)
  return await getLocalDataByKey(key)
}

export async function getLocalDataByKey(key) {
  const storageName = getStorageNameByKey(key)
  let data = localStorage.getItem(storageName)
  if (data) {
    // move data from local storage to IndexedDB
    const actionCardData = JSON.parse(data)
    await actionCardDbStore.save(key, null, actionCardData)
    localStorage.removeItem(storageName)
    return actionCardData
  } else {
    data = await actionCardDbStore.get(key)
    return data ? data : null
  }
}

export async function saveLocalData(data, playbookId) {
  const key = getActionCardDataKey(playbookId)
  await actionCardDbStore.save(key, playbookId, data)
}

export async function saveLocalDataByKey(data, key) {
  await actionCardDbStore.save(key, null, data)
}

export async function clearLocalData(playbookId) {
  await actionCardDbStore.removeByPlaybook(playbookId)
  await deleteFileQuestionsDb(playbookId)
}

export function getStorageName(playbookId) {
  const key = getActionCardDataKey(playbookId)
  return getStorageNameByKey(key)
}

function getStorageNameByKey(key) {
  return `lnd_actionCardData_${key}`
}

function getActionCardDataKey(playbookId) {
  const searchParams = new URL(location.href).searchParams
  const keys = [...searchParams.keys()].filter(key => key.startsWith('f_'))
  let key = `${playbookId}`
  if (keys.length) key += `_${keys.map(key => `${key.slice(2)}=${searchParams.get(key)}`).join('_')}`
  return key
}
